'use client'

import { ThemeProvider } from 'next-themes'
import { NuqsAdapter } from 'nuqs/adapters/next/app'
import { type ReactNode, Suspense } from 'react'

import { ThemeToaster } from '@/components/theme-toaster'
import { ConfirmDialogProvider } from '@/components/ui/confirm-dialog'
import { PointerEventsGuard } from '@/components/ui/pointer-events-guard'

export function RootProviders({ children }: { children: ReactNode }) {
  return (
    <NuqsAdapter>
      <ThemeProvider
        attribute="class"
        defaultTheme="system"
        enableSystem
        disableTransitionOnChange
      >
        <ConfirmDialogProvider>{children}</ConfirmDialogProvider>
        <Suspense fallback={null}>
          <ThemeToaster />
        </Suspense>
        <PointerEventsGuard />
      </ThemeProvider>
    </NuqsAdapter>
  )
}
